import {
  faCertificate,
  faEnvelopesBulk,
  faFile,
  faListCheck,
  faPeopleGroup,
  faSitemap,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import React, { type FC } from "react";
import { ContentContainer } from "../../components/content/ContentContainer";
import { PageHeader } from "../../components/content/PageHeader";
import { SettingsSearch } from "../../components/content/SettingsSearch";

export const SettingsOverviewPage: FC<{}> = (props) => {
  return (
    <ContentContainer size={"md"}>
      <PageHeader>Instellingen</PageHeader>
      <SettingsSearch
        tiles={[
          {
            icon: faPeopleGroup,
            title: "Assessors",
            subTitle: "Beheer assessors, uitschakelen, archiveren",
            href: `/settings/assessors`,
          },
          {
            icon: faUserPlus,
            title: "Gebruikers & Toegang",
            subTitle: "Gebruikers, Rechten en Toegang",
            href: `/settings/users`,
          },
          {
            icon: faEnvelopesBulk,
            title: "E-mail import",
            subTitle: "Toegestane e-emails beheren",
            href: `/settings/email-import`,
          },
          {
            icon: faCertificate,
            title: "Certificeringstypes",
            subTitle: "App standaard-opties voor certificering",
            href: `/settings/certification-types`,
          },
          {
            icon: faFile,
            title: "Bijlagen",
            subTitle: "(Standaard) Bijlagen",
            href: `/settings/attachments`,
          },
          {
            icon: faListCheck,
            title: "Checklisten",
            subTitle: "Beschikbare checklisten beheren",
            href: `/settings/checklists`,
          },
          {
            icon: faSitemap,
            title: "Hijscategorie assistent",
            subTitle: "Vragen en uitkomsten van de hijscategorie assistent beheren",
            href: `/settings/hijscategorie-assistent`,
          },
        ]}
      />
    </ContentContainer>
  );
};
